import * as yup from 'yup';

export const shopifySchema = yup.object().shape({
  shopify_url: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(2, 'Informe um alias válido.')
    .max(400, 'Informe um alias válido.'),
  secret_id: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(10, 'Informe um Client ID válido.')
    .max(200, 'Informe um Client ID válido.'),
  secret_api_key: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(10, 'Informe uma Secret válida.')
    .max(200, 'Informe uma Secret válida.'),
});

export const updateShopifySchema = yup.object().shape({
  secret_id: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(10, 'Informe um Client ID válido.')
    .max(200, 'Informe um Client ID válido.')
    .test('valid secret id', 'Insira um Client ID válido.', value => {
      if (value?.includes('*')) return false;

      return true;
    }),
  secret_api_key: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(10, 'Informe uma Secret válida.')
    .max(200, 'Informe uma Secret válida.')
    .test('valid secret api key', 'Insira uma Secret válida.', value => {
      if (value?.includes('*')) return false;

      return true;
    }),
});
